var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"tips"},[_vm._v("点击小方块进行预约,一个小方块代表时长15分钟,一个小时划分为4个小方块")])])}]

export { render, staticRenderFns }